<template>
  <section
    class="z-30 w-full bg-gray-100 p-3 desktop:w-[calc(100%-280px)] desktop:py-12 desktop:pl-12 desktop:pr-0"
  >
    <LoaderBounce v-if="isLoading" class="py-52" />
    <template v-else>
      <h1
        data-test="appList__category-h1-title"
        class="text-2xl font-bold leading-[48px] desktop:text-4xl"
      >
        {{ $t(`menu.product.category.${route.params.subcategory}`) }}
      </h1>

      <div class="mt-8 desktop:mt-12">
        <div v-for="(collection, index) in collections" :key="collection.code">
          <h2
            data-test="appList__collection-name"
            class="mb-6 text-xl font-bold leading-[36px] desktop:text-[28px]"
            :class="index !== 0 && 'mt-7'"
          >
            {{ $t(`menu.product.collection.${collection.code}`) }}
          </h2>
          <AreaCategoryProducts :products="collection.products" />
        </div>
      </div>
    </template>
  </section>
</template>

<script setup lang="ts">
  interface IProps {
    isLoading: boolean;
  }

  withDefaults(defineProps<IProps>(), {
    isLoading: true,
  });

  const route = useRoute();
  const categoryStore = useCategoryStore();
  const { collections } = storeToRefs(categoryStore);
</script>
